import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { computed } from "vue";
import { i18n } from "@/i18n";
import type { TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import { AnalyticsV2ElementType, ColumnCategory } from "@/models/etc/types";
import { generalStore } from "@/store/general";
import { auxStore } from "@/store/auxillary";
import { formatSimpleHtml, wrapPhones } from "./cellFormat";


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleCellElementLite',
  props: {
    element: {},
    entityId: {},
    creatorId: {}
  },
  emits: ["refreshNeeded"],
  setup(__props: any) {

const props = __props;



const t = (k: string) => i18n.global.t(k);
const gstore = generalStore();
const aux = auxStore();

/* Контактная колонка (детали персоны у элемента-персоны): в ней номера телефонов
   делаем кликабельными для отправки запроса на звонок (без нативного tel:-набора). */
const isContactType = computed<boolean>(() =>
  props.element.Category === ColumnCategory.PersonDetails &&
  gstore.selectedItem?.DestType === AnalyticsV2ElementType.Person,
);

/** v-once невозможен (контент меняется при reactivity row-replace), но работа функции дешёвая. */
const renderedHtml = computed(() => wrapPhones(formatSimpleHtml(props.element, t), isContactType.value));

// Анти-дребезг: защита от двойного запроса на звонок при быстром двойном клике,
// не зовём callPhoneNumber чаще раза в 600мс на одну ячейку.
let lastCallTs = 0;

function onCellClick(e: MouseEvent) {
  const target = e.target as HTMLElement | null;
  const phone = target?.closest?.(".phone-number") as HTMLElement | null;
  if (!phone) return;
  const number = phone.dataset.phone;
  if (!number) return;
  const now = Date.now();
  if (now - lastCallTs < 600) return;
  lastCallTs = now;
  aux?.callPhoneNumber?.(number);
}

return (_ctx: any,_cache: any) => {
  return (_ctx.element.DisplayType === 6)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "qtl-simple-tag",
        innerHTML: renderedHtml.value,
        onClick: onCellClick
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "qtl-simple-html",
        innerHTML: renderedHtml.value,
        onClick: onCellClick
      }, null, 8, _hoisted_2))
}
}

})